"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuItem = void 0;

var _find2 = _interopRequireDefault(require("lodash/find"));

var _useMenuItems = require("./useMenuItems");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useMenuItem = function useMenuItem(menuItemCode) {
  var menuItems = (0, _useMenuItems.useMenuItems)();
  return (0, _find2["default"])(menuItems, function (item) {
    return item.menuItemCode === menuItemCode;
  });
};

exports.useMenuItem = useMenuItem;